export default "__VITE_ASSET__7019a02d__"